export enum ReclamationReason {
  EDGES_DAMAGED = 'defect_goods2.edges_damaged',
}
